package link.erpango.quip.theme

import androidx.compose.ui.unit.dp

/**
 * Dimensiones estándar de QUIP para mantener consistencia visual
 */
object QuipDimens {
    // Padding
    val padding2 = 2.dp
    val padding4 = 4.dp
    val padding6 = 6.dp
    val padding8 = 8.dp
    val padding10 = 10.dp
    val padding12 = 12.dp
    val padding16 = 16.dp
    val padding20 = 20.dp
    val padding24 = 24.dp

    // Iconos
    val iconSize16 = 16.dp
    val iconSize20 = 20.dp
    val iconSize24 = 24.dp
    val iconSize28 = 28.dp
    val iconSize48 = 48.dp

    // Bordes redondeados
    val cornerRadius8 = 8.dp
    val cornerRadius12 = 12.dp
    val cornerRadius16 = 16.dp

    // Alturas
    val buttonHeight = 56.dp
    val dropdownItemHeight = 48.dp

    // Elevación
    val elevationSmall = 2.dp
    val elevationMedium = 4.dp
    val elevationLarge = 8.dp
}
